module.exports = __webpack_public_path__ + "img/Hino.4fa1b4a0.jpg";